<script lang="ts">
    import { mealyMachine_executeSingleStep } from "../../actions/machine";
    import { getUpdateMachineState } from "../../mealy/context";
    import type { MealyExecutionState } from "../../state/executionState";
    import type { MachineStateMealy_Kunstautomat1, MachineStateMealy_Kunstautomat2 } from "../../state/machineState";
    import { EditMode } from "../../state/uiState";
    import { callIfExecuted, mealyStartAnimation, startAnimationIfExecuted } from "../../mealy/mealyExecute";

    import Coin1Euro from "../Coin1Euro.svelte";
    import Coin2Euro from "../Coin2Euro.svelte";
    import Kunstautomat from "./Kunstautomat.svelte";
    import Kunstwerk from "./Kunstwerk.svelte";

    const updateMachineState = getUpdateMachineState();

    export let machineState: MachineStateMealy_Kunstautomat1 | MachineStateMealy_Kunstautomat2;
    export let mealyExecutionState: MealyExecutionState;
    export let isExecuting: boolean;
    export let show2Euro: boolean;
    import * as F from 'fp-ts/function';
    

    // function handleDrop(event) {
    //     // console.log('drop')
    //     const char = event.dataTransfer.getData("text/plain");

    //     if (isExecuting) {
    //         const [newMachineState, stepHasBeenExecuted] = mealyMachine_executeSingleStep(machineState, char);
    //         updateMachineState(newMachineState);
    //     }
    // }

    // function allowDrop(event) {
    //     event.preventDefault();
    // }

    // function handleDragStart(event, char) {        
    //     event.dataTransfer.setData('text', char);
        
    // }

    $: showWare = (() => {
        if ((machineState.uiState.editMode === EditMode.EXECUTION || machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION) && mealyExecutionState.lastTransition) {
            return mealyExecutionState.lastTransitionOutput === 'Ware'
        }
        else {
            return false;
        }
    })()

    function executeStep(char: string) {
        if (machineState.uiState.editMode === EditMode.EXECUTION || machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION) {
        // if (isExecuting) {
            const [newMachineState, hasBeenExecuted] = F.pipe(
                mealyMachine_executeSingleStep(machineState, char),
                startAnimationIfExecuted,
            );

            if (hasBeenExecuted && newMachineState.executionState.lastTransitionOutput === 'Ware') {
                kunstwerk.generate();
            }

            updateMachineState(newMachineState);
        }
    }

    $: showCoin1 = ((machineState.uiState.editMode === EditMode.EXECUTION || machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION) && mealyExecutionState.lastTransitionOutput)
        ? mealyExecutionState.lastTransitionOutput === '1€' ||  mealyExecutionState.lastTransitionOutput === '3€'
        : false;

    $: showCoin2 = ((machineState.uiState.editMode === EditMode.EXECUTION || machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION) && mealyExecutionState.lastTransitionOutput)
        ? mealyExecutionState.lastTransitionOutput === '2€' ||  mealyExecutionState.lastTransitionOutput === '3€'
        : false;

    $: coinPositionYOffset = (() => {
        if (machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION && (showCoin1 || showCoin2)) {
            let offset = tweenNumber(50, 0, machineState.animation.progress);
            return offset;
        } else {
            return 0;
        }
    })()

    let kunstwerk;

    function tweenNumber(from: number, to: number, progress: number) {
        return (to-from) * progress + from;
    }

    $: kunstwerkPositionYOffset = (() => {
        if (machineState.uiState.editMode === EditMode.EXECUTION_TRANSITION) {
            if (mealyExecutionState.lastTransitionOutput === 'Ware') {
                let offset = tweenNumber(50, 0, machineState.animation.progress);
                return offset;
            } else {
                return 0;
            }
        } else {
            return 0;
        }
    })()
</script>

<div style="display: flex; flex-direction: row; height: 400px; margin: 10px;">
    <!-- <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xml:space="preserve" width="203.3" height="400"></svg> -->
    <svg height="100%" viewBox="0 0 203.3 400">
        <Kunstautomat />

        <!-- Dropzone für die Münzen  -->
        <!-- <rect 
            on:dragover={allowDrop}
            on:drop={handleDrop}
            x="395"
            y="350"
            width="50"
            height="80"
            fill="white"
            stroke="red"
            stroke-width="10"
            ry="2"
        /> -->

        <!-- Münzen  -->
        <g transform="translate(140 330)">
            <rect x="0" y="0" width="50" height="50" fill="lightgrey" ry="10" />

            <clipPath id="clipCoins">
                <rect x="-25" y="0" width="100" height="50" ry="10"/>
            </clipPath>

            <g clip-path="url(#clipCoins)">
                <g transform="translate(0 {-coinPositionYOffset})">
                    {#if showCoin1}
                        <g transform="translate(-15 5) scale(0.04)">
                            <Coin1Euro />
                        </g>
                    {/if}
                    {#if showCoin2}
                        <g transform="translate(15 5) scale(0.04)">
                            <Coin2Euro />
                        </g>
                    {/if}
                </g>
            </g>
        </g>

        <!-- Kunstwerk  -->
        <g transform="translate(20 330)">
            <rect x="0" y="0" width="100" height="50" fill="lightgrey" ry="10"/>

            <clipPath id="clipKunstwerk">
                <rect x="0" y="0" width="100" height="50" ry="10"/>
            </clipPath>
            
            <g clip-path="url(#clipKunstwerk)">
                <g transform="translate(0 {-kunstwerkPositionYOffset})">
                    <Kunstwerk
                        bind:this={kunstwerk}
                        isVisible={showWare} 
                    />
                </g>
            </g>
        </g>

        <!-- Buttons für Ware und Geld  -->
        <foreignObject x="20" y="285" width="75" height="35">
            <button style="width: 75px; height: 35px; padding:1px; font-size: 20px" on:click={() => executeStep('Ware')}>Ware</button>
        </foreignObject>
        <foreignObject x="110" y="285" width="75" height="35">
            <button style="width: 75px; height: 35px; padding:1px; font-size: 20px" on:click={() => executeStep('Geld')}>Geld</button>
        </foreignObject>
    </svg>

    <div style="display: flex; flex-direction: column; margin-left: 10px;">
        <!-- <div>
            einwerfen:
        </div> -->
        <button on:click={() => executeStep('1€')}>
            <svg width="50px" viewBox="0 0 1000 1000">
                <Coin1Euro />
            </svg>
        </button>

        <div style="height: 10px;"></div>

        {#if show2Euro}
            <button on:click={() => executeStep('2€')}>
                <svg width="50px" viewBox="0 0 1000 1000">
                    <Coin2Euro />
                </svg>
            </button>
        {/if}
        <!-- <div
            draggable="true"
            on:dragstart={(event) => handleDragStart(event, '1€')}
        >
            <svg width="50px" viewBox="0 0 1000 1000">
                <Coin1Euro />
            </svg>
        </div>

        <div
            draggable="true"
            on:dragstart={(event) => handleDragStart(event, '2€')}
            style="padding-top: 10px;"
        >
            <svg width="50px" viewBox="0 0 1000 1000">
                <Coin2Euro />
            </svg>
        </div> -->
    </div>
</div>

<style>
    button {
        margin: 0;
        padding: 4px;
        height: 50px;
        width: 50px;
        box-sizing: content-box;

        border: 1px solid #ccc;
        border-radius: 2px;
        color: #000000;

        background-color: #f0f0f0;
    }

    button:hover {
        background-color:#d6d6d6;
        color: #000000;
    }
</style>